import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <h3 className="footer-title">Youth Supporting Roots</h3>
        <div className="footer-content">
          <p className="footer-address">
            1715 Rosetta Drive Durham, NC 27701 • 919 358 2048 • Email: info@youthsupportingroots.org
          </p>
          <a 
            href="https://zeffy.com/en-US/donation-form/donate-to-make-a-difference-18999" 
            className="donate-link"
            target="_blank"
            rel="noopener noreferrer"
          >
            Donate Today!
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
